
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../base/Card';

const services = [
  {
    title: 'Roof Installation',
    description: 'Complete roof installation services with premium materials and expert craftsmanship.',
    icon: 'ri-home-4-line',
    image: 'https://public.readdy.ai/ai/img_res/ce7e6ea432737f6a663ee4d576e0fbd3.jpg'
  },
  {
    title: 'Roof Repair',
    description: 'Fast and reliable roof repair services to protect your home from the elements.',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20roof%20repair%20work%20being%20done%20on%20residential%20house%2C%20workers%20fixing%20damaged%20shingles%2C%20construction%20tools%20and%20materials%2C%20clear%20blue%20sky%2C%20high%20quality%20photography%2C%20realistic%20lighting%2C%20professional%20workmanship&width=400&height=300&seq=roof-repair-service&orientation=landscape'
  },
  {
    title: 'Solar Panel Installation',
    description: 'Reduce energy costs with professional solar panel installation and integration.',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=Solar%20panel%20installation%20on%20modern%20residential%20roof%2C%20professional%20technicians%20installing%20photovoltaic%20panels%2C%20clean%20blue%20sky%20background%2C%20high%20quality%20architectural%20photography%2C%20sustainable%20energy%20technology&width=400&height=300&seq=solar-installation-service&orientation=landscape'
  },
  {
    title: 'Roof Inspection',
    description: 'Comprehensive roof inspections to identify issues before they become major problems.',
    icon: 'ri-search-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20roof%20inspector%20with%20clipboard%20examining%20residential%20roof%2C%20construction%20professional%20in%20safety%20gear%20reviewing%20roof%20condition%2C%20detailed%20inspection%20process%2C%20clear%20blue%20sky%20background%2C%20high%20quality%20photography%2C%20realistic%20lighting%2C%20professional%20assessment%20documentation&width=400&height=300&seq=roof-inspection-service&orientation=landscape'
  }
];

export default function Services() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Professional roofing and solar solutions tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-gray-200 overflow-hidden">
              {service.image && (
                <div className="h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              )}
              
              <CardHeader>
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <CardTitle className="text-xl">{service.title}</CardTitle>
              </CardHeader>
              
              <CardContent>
                <CardDescription className="text-base">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
